<template>
  <div class="container">
    <h1 class="mb-4">Movimiento {{ movement.id }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details">
              <fai icon="info"/>&nbsp;Generales
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="movement.id">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-info" @click="goToEdit">
                  <fai :icon="['far','edit']"/> Editar
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Nombre</h5>
                  <span>{{ movement.full_name }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Cuenta</h5>
                  <span>{{ movement.account_id }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Salario</h5>
                  <span>{{ movement.salary | formatCurrency }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Monto del movimiento</h5>
                  <span>{{ movement.amount | formatCurrency }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Estatus</h5>
                  <span>{{ movement.status }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Fecha de confirmación</h5>
                  <span>{{ movement.confirm_date | reverseDate }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>¿Es retiro total?</h5>
                  <span>{{ movement.total }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Fecha de creación</h5>
                  <span>{{ movement.created_at }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Fecha de actualización</h5>
                  <span>{{ movement.updated_at }}</span>
              </div>
            </div>
          </div>
          <!--end: Details -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import movementsService from '@/services/movements'
import SysTable from '@/components/shared/Table'

export default {
  name: 'MovementDetail',

  components: { SysTable },

  data () {
    return {
      movement: {}
    }
  },
  created: function () {
    const id = this.$route.params.id

    movementsService.getById(id).then(res => {
      this.movement = res.data
    })
  },
  methods: {
    goToEdit () {
      const id = this.$route.params.id
      this.$router.push({ name: 'movement_update', params: { id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/movements/MovementDetail.vue